import { createContext } from 'react';

export const PTWDefaultState = {
	isPrinting: false,
};

export const PTWContext = createContext(PTWDefaultState);